<template>
    <v-card>
      <v-card-title>
        <span class="headline primary--text">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="item.firstName"
                  label="Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="item.lastName"
                  label="Surname"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="item.emailAddress"
                  label="Email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="item.mobile"
                  label="Mobile"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="item.regNumber"
                  label="Reg Number (CA-123-456)"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="warning"
            text
            @click="close"
        >
          Cancel
        </v-btn>
        <v-btn
            color="primary"
            @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
export default {
  name: "CreateDialog",
  props: {
    formTitle: String,
    item: Object,
    closeFunction: Function,
    saveFunction: Function,
    serviceProviders: Array
  },
  methods: {
    close() {
      this.closeFunction();
    },
    save() {
      this.saveFunction();
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>